import React, { Component } from 'react';
import { Editor } from 'slate-react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { markTypesToCheck } from '@components/userDocuments/editDocument/editJournal/slateUtilities/renderMarksEnums';
import { clearGlobalSelection } from '@utility/clearGlobalSelection';
import schema from './Schema';
import renderBlock from './renderBlock';
import Actions from '../../../../../../../../store/actions';
import {
  SET_SELECTION,
  INSERT_TEXT,
  ADD_MARK,
  REMOVE_MARK,
} from '../../../../../../../../constants/selectionOpts';
import keyDown from './utils/keyDown';
import paste from './utils/paste';
import renderMark from '../../../../../editJournal/slateUtilities/renderMark';
import ContentCardWrapper from '../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/ContentCard';
import Logger from '../../../../../../../../utility/services/Logger';
import { TYPING_DEBOUNCE } from '../../../../../../../../constants/debounce';
import References from './references';
import SnackBarAlerts from '../../../../../../../common/snackBarAlerts/snackBarAlerts';
import resumePlugins from './resumePlugins';
import stopCommentExtension from '../../../../../../../../utility/commentExtension';
import CommentsCard from '../../../../../../../comments/commentsCard';
import setMarksChange from '../PersonalInfo/setMarksChange';
import setMarksOnBlur from './setMarksOnBlur';
import commentChange from './commentChange';
import expertTipsIntro from './utils/expertTips/expertTipsIntro';
import { marksChange } from '../PersonalInfo/basicInput';
import { fnBrowserDetect } from '../../../../../../../../utility/browsers';
import { CHROME, SAFARI } from '../../../../../../../../utility/enums/browsers';
import removeMarksFromValue from './utils/removeMarksFromValue';

class Organizations extends Component {
  constructor(props) {
    super(props);

    const { sectionKey } = props;
    const value = props[sectionKey];
    this.state = {
      value,
      snackBar: null,
    };
    this.timer = null;
  }

  componentDidMount = () => {
    if (fnBrowserDetect() !== SAFARI) {
      this.editorRef.focus();
    }
    const {
      sectionKey,
      resetHistory,
      updateFocusedEditor,
      setMarkType,
      italic,
      underline,
      bold,
    } = this.props;
    if (this.editorRef) {
      const {
        value: {
          focusBlock,
          selection: { isFocused },
        },
      } = this.editorRef;
      if (this.editorRef && focusBlock && isFocused) {
        this.editorRef?.deselect()?.blur();
      }
    }
    updateFocusedEditor('section', this.editorRef);
    // Marks Setting it back to default
    if (italic !== false || bold !== false || underline !== false) {
      setMarkType({
        bold: false,
        italic: false,
        underline: false,
      });
    }
    const { [sectionKey]: sectionValue } = this.props;
    resetHistory({
      history: {
        tail: {
          data: {
            activeElementData: sectionValue,
            sectionKey,
          },
          next: null,
          prev: null,
          index: 0,
          changeData: [],
        },
      },
    });
  };

  componentDidUpdate = (prevProps) => {
    const { sectionKey } = this.props;
    if (prevProps.sectionKey !== sectionKey) return;

    try {
      const {
        [sectionKey]: { document: previousDocument },
      } = prevProps;

      const {
        [sectionKey]: incomingSection,
        updateEventTypes,
        eventTypes,
      } = this.props;

      const { document: currentDocument } = incomingSection;
      if (
        previousDocument !== currentDocument &&
        eventTypes.length &&
        (eventTypes[eventTypes.length - 1].type === 'undo' ||
          eventTypes[eventTypes.length - 1].type === 'redo')
      ) {
        this.setState({ value: incomingSection });

        this.setButtonState(incomingSection);
        updateEventTypes({ isArray: true });
      }
    } catch (err) {
      Logger.LogError(err);
      this.setSnackBar('error');
    }
  };

  componentWillUnmount = () => {
    if (fnBrowserDetect() === SAFARI) {
      clearGlobalSelection();
    }
  };

  setButtonState = (incomingSection) => {
    const { setMarkType, bold, italic, underline } = this.props;
    const activeMarks = JSON.parse(JSON.stringify(incomingSection.activeMarks));
    const marks = {
      bold: false,
      italic: false,
      underline: false,
    };
    activeMarks.forEach(({ type }) => {
      if (type in marks) {
        marks[type] = true;
      }
    });
    if (
      bold !== marks.bold ||
      italic !== marks.italic ||
      underline !== marks.underline
    ) {
      setMarkType(marks);
    }
  };

  onChange = ({ value, operations }) => {
    try {
      const { document: currentDocument } = value;
      const {
        sectionKey,
        setMarkType,
        [sectionKey]: { document: previousDocument },
        updateSection,
        bold,
        italic,
        underline,
        unorderedList,
        comment,
      } = this.props;

      const operationsArray = operations.toArray();
      const { length } = operationsArray;

      expertTipsIntro({
        length,
        operationsArray,
        props: this.props,
        editorRef: this.editorRef,
      });

      const isComment = commentChange(operationsArray);

      let isSelectionOps = true;

      operationsArray.forEach((oper) => {
        if (
          oper.type !== SET_SELECTION &&
          !(
            oper.type === ADD_MARK &&
            markTypesToCheck.some((markType) => markType === oper.mark.type)
          ) &&
          !(
            oper.type === REMOVE_MARK &&
            markTypesToCheck.some((markType) => markType === oper.mark.type)
          )
        )
          isSelectionOps = false;
      });

      if (isComment) isSelectionOps = false;

      /**
       * Debounce only when user types rest of the events
       * dispatch immediately
       */

      const debounce = operationsArray.some(
        (operation) => operation.type === INSERT_TEXT,
      );

      /**
       * Remove marks from value, which are not required to be saved in the database
       * And avoid the marks to be updated to redux store
       * */
      const newValue = removeMarksFromValue(value);

      if (currentDocument !== previousDocument && !isSelectionOps) {
        clearTimeout(this.timer);
        if (debounce) {
          this.timer = setTimeout(() => {
            updateSection({ key: sectionKey, data: { value: newValue } });
            setMarksChange({
              value: newValue,
              bold,
              italic,
              underline,
              unorderedList,
              comment,
              setMarkType,
            });
          }, TYPING_DEBOUNCE);
        } else {
          updateSection({ key: sectionKey, data: { value: newValue } });
          setTimeout(
            () =>
              setMarksChange({
                value: newValue,
                bold,
                italic,
                underline,
                unorderedList,
                comment,
                setMarkType,
              }),
            0,
          );
        }
      }
      this.setState({ value });
      if (isSelectionOps && value.selection.isFocused) {
        setTimeout(
          () =>
            setMarksChange({
              value: newValue,
              bold,
              italic,
              underline,
              unorderedList,
              comment,
              setMarkType,
            }),
          0,
        );
      }
    } catch (err) {
      Logger.LogError(err);
      this.setSnackBar('error');
    }
  };

  setSnackBar = (type) => {
    if (type === 'error')
      this.setState({
        snackBar: {
          showSnackBar: true,
          snackBarMessage: 'Apologies, something went wrong!', // error state management @layer2 controls specifix messages as per error
          snackBarType: 'error',
          errorCode: 'onChangeOrg',
        },
      });
  };

  dateRef = {};

  setDateRef = (nodeKey, date) => {
    this.dateRef[nodeKey] = date;
  };

  renderMark = (...args) => {
    const argumentsData = args;
    const { formatType } = this.props;
    argumentsData[0].formatType = formatType;
    return renderMark(...argumentsData);
  };

  onKeyDown = (event, editor, next) => {
    const {
      sectionKey,
      updatePopUpKeys,
      showCommentCard,
      showContextCard,
      activePlan,
      subscriptionStatus,
      formatType,
      showExpertTips,
      setExpertTips,
      statusBarRef,
    } = this.props;

    /**
     * Stop the extension of comment mark at the beginning &
     * at the end of comment text
     */
    stopCommentExtension({
      editor: this.editorRef,
      showCommentCard,
      showContextCard,
      event,
      updatePopUpKeys,
    });
    const isPreventDefault = keyDown({
      sectionKey,
      event,
      editor,
      activePlan,
      subscriptionStatus,
      formatType,
      dateRef: this.dateRef,
      updatePopUpKeys,
      showCommentCard,
      showContextCard,
      setExpertTips,
      showExpertTips,
      statusBarRef,
      props: this.props,
    });
    if (isPreventDefault) return;

    next();
  };

  onPaste = (event, editor, next) => {
    const { formatType } = this.props;
    const isPreventDefault = paste({
      event,
      editor,
      formatType,
      setSnackBar: this.setSnackBarAlert,
    });
    if (isPreventDefault) return;
    next();
  };

  onFocus = async (_event, editor) => {
    const { updateFocusedEditor } = this.props;
    const { value } = this.state;
    updateFocusedEditor('section');

    const resp = await marksChange({ value, ...this.props });
    // if (resp && fnBrowserDetect() !== CHROME) next();
    if (resp && fnBrowserDetect() !== CHROME) {
      editor.focus();
    }
  };

  onBlur = (_event, editor, next) => {
    const {
      updateFocusedEditor,
      setMarkType,
      componentKey,
      bold,
      italic,
      underline,
      unorderedList,
      comment,
    } = this.props;
    updateFocusedEditor();
    setTimeout(() => {
      setMarksOnBlur({
        componentKey,
        bold,
        italic,
        underline,
        unorderedList,
        comment,
        setMarkType,
      });
      editor.blur();
    }, 0);

    next();
  };

  renderBlock = (props, editor, next) => {
    const {
      statusBarRef,
      mostUsedToolSetRef,
      isTitleEditing,
      sectionKey,
      selectedPlan,
      universityPlan,
      saveDocument,
    } = this.props;
    return renderBlock(
      props,
      editor,
      next,
      'Resume',
      this.setDateRef,
      statusBarRef,
      mostUsedToolSetRef,
      isTitleEditing,
      sectionKey,
      selectedPlan,
      universityPlan,
      saveDocument,
    );
  };

  handleClose = () => {
    const { snackBar } = this.state;
    this.setState({
      snackBar: {
        ...snackBar,
        showSnackBar: false,
      },
    });
  };

  setSnackBarAlert = ({ snackBarMessage, snackBarType }) => {
    const { showSnackBar } = this.state;
    this.setState({
      snackBar: {
        snackBarMessage,
        snackBarType,
        showSnackBar: !showSnackBar,
      },
    });
  };

  render() {
    const { value, snackBar } = this.state;
    const {
      sectionKey,
      show,
      manualShow,
      toggleReferenceModal,
      toggleManualReferenceModal,
      saveDocument,
      setSaveToggler,
      permission,
      showCommentCard,
      showContextCard,
      formatType,
      parentRef,
    } = this.props;

    let focusBlockType;
    const { focusBlock } = value;
    if (focusBlock) {
      const { type } = focusBlock;
      focusBlockType = type;
    }
    return (
      <>
        <ContentCardWrapper className="sectionKey">
          <Editor
            ref={(editor) => {
              this.editorRef = editor;
            }}
            plugins={resumePlugins}
            schema={schema[sectionKey]}
            value={value}
            onChange={this.onChange}
            onKeyDown={this.onKeyDown}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            renderMark={this.renderMark}
            onPaste={this.onPaste}
            renderNode={this.renderBlock}
            sectionKey={sectionKey}
            className="editor"
            parentRef={parentRef}
            saveDocument={saveDocument}
            setSaveToggler={setSaveToggler}
          />
          {/* TODO: Optimize this with conditional render */}
          {this.editorRef && (
            <References
              show={show}
              manualShow={manualShow}
              editor={this.editorRef}
              closeReferenceModal={toggleReferenceModal}
              closeManualReferenceModal={toggleManualReferenceModal}
            />
          )}
          {focusBlock &&
            (focusBlockType === showCommentCard.focusBlockType ||
              focusBlockType.includes(showCommentCard.focusBlockType) ||
              focusBlockType === showContextCard.focusBlockType ||
              focusBlockType.includes(showContextCard.focusBlockType)) && (
              <CommentsCard
                setSnackBarState={this.setSnackBarState}
                permission={permission}
                saveDocument={saveDocument}
                editorRef={this.editorRef}
                formatType={formatType}
              />
            )}
        </ContentCardWrapper>
        {snackBar && (
          <SnackBarAlerts
            showSnackBar={snackBar.showSnackBar}
            handleClose={this.handleClose}
            snackBarMessage={snackBar.snackBarMessage}
            snackBarType={snackBar.snackBarType}
          />
        )}
      </>
    );
  }
}

Organizations.propTypes = {
  sectionKey: propTypes.string.isRequired,
  updateSection: propTypes.func.isRequired,
  updateFocusedEditor: propTypes.func.isRequired,
  history: propTypes.objectOf(propTypes.object).isRequired,
  resetHistory: propTypes.func.isRequired,
  show: propTypes.bool.isRequired,
  toggleManualReferenceModal: propTypes.func.isRequired,
  toggleReferenceModal: propTypes.func.isRequired,
  updateEditorRef: propTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { sectionKey } = ownProps;
  return {
    [sectionKey]: state.editResumeFormReducer[sectionKey],
    history: state.editResumeFormReducer.history,
    show: state.referenceModal.show,
    manualShow: state.referenceModal.manualShow,
    dragType: state.editResumeFormReducer.dragType,
    showCommentCard: state.commentsReducer.commentCard,
    showContextCard: state.commentsReducer.isContextMenu,
    activePlan: state.userInfoReducer.activePlan,
    subscriptionStatus: state.userInfoReducer.subscriptionStatus,
    formatType: state.editResumeFormReducer.formatType,
    bold: state.mostUsedToolsetReducer.marks.bold,
    italic: state.mostUsedToolsetReducer.marks.italic,
    underline: state.mostUsedToolsetReducer.marks.underline,
    unorderedList: state.mostUsedToolsetReducer.marks.unorderedList,
    comment: state.mostUsedToolsetReducer.marks.comment,
    eventTypes: state.editResumeFormReducer.eventTypes,
    inputIntro: state.userInfoReducer.inputIntro,
    showExpertTips: state.mostUsedToolsetReducer.showExpertTips,
    autoPromptExpertTips: state.mostUsedToolsetReducer.autoPromptExpertTips,
    user: state.user,
    userPreferences: state.editResumeFormReducer.userPreferences,
    universityPlan: state.userInfoReducer.universityPlan,
    selectedPlan: state.userInfoReducer.selectedPlan,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updatePopUpKeys: (params) => {
    dispatch(Actions.commentActions.updatePopUpKeys(params));
  },
  updateEventTypes: (params) =>
    dispatch(Actions.editResumeFormActions.updateEventTypes(params)),
  updateSection: (params) =>
    dispatch(Actions.editResumeFormActions.updateSection(params)),
  resetHistory: (params) =>
    dispatch(Actions.editResumeFormActions.resetHistory(params)),
  showError: (params) =>
    dispatch(Actions.editResumeFormActions.showError(params)),
  toggleReferenceModal: () =>
    dispatch(Actions.referenceModalActions.toggleReferenceModal()),
  toggleManualReferenceModal: () =>
    dispatch(Actions.referenceModalActions.toggleManualReferenceModal()),
  setMarkType: (params) =>
    dispatch(Actions.mostUsedToolsetActions.setMarkType(params)),
  setExpertTips: (params) =>
    dispatch(Actions.mostUsedToolsetActions.setExpertTips(params)),
  setInputIntro: (params) =>
    dispatch(Actions.userInfoActions.setInputIntro(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Organizations);
